import { Alert, Box, Button, Card, CardContent, CardHeader, FormControl, FormControlLabel, FormLabel, Grid2, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { JENIS_KELAMIN, JENJANG_TUJUAN } from '../../helper/Constant';
import { Commons } from '../../helper/CommonService';

function PraDaftar({ handleChange, dataSantri, dataJenjang }) {
    const { tingkat } = useParams();
    const [programs, setPrograms] = useState([]);
    useEffect(() => {
        if (!dataSantri || !dataSantri.jenis_kelamin) {
            handleChange("jenis_kelamin", JENIS_KELAMIN.LAKILAKI);
        }
    }, [dataSantri, handleChange]);

    useEffect(() => {
        const fetchPrograms = async () => {
            const data = await Commons.GetAdditionalInformation("programs");
            setPrograms(data || []);
        };
        fetchPrograms();
    }, []);


    useEffect(() => {
        if (tingkat && (!dataJenjang || !dataJenjang.jenjang_tujuan)) {
            handleChange("jenjang_tujuan", tingkat);
        }
    }, [tingkat]);

    return (
        <>
            <Card>
                <CardHeader title="Pra-Pendaftaran" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Alert variant="filled" severity="info">
                        Siapkan Kartu Keluarga (KK) dan Rapor 2 semester terakhir untuk mempermudah dalam pengisian formulir
                    </Alert>
                    <Box sx={{ mt: 3 }}>
                        <FormControl>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Nama Calon Santri Sesuai KK</FormLabel>
                            <TextField required value={dataSantri?.nama} name='nama' onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth></TextField>

                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px", "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Nomor Induk Kependudukan (NIK) calon Santri</FormLabel>
                            <TextField type='number' required value={dataSantri?.nik} name='nik' onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth></TextField>

                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px", "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Nomor KK calon santri</FormLabel>
                            <TextField type='number' required value={dataSantri?.no_kk} name='no_kk' onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth></TextField>

                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px", "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Tanggal Lahir</FormLabel>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker required format="DD/MM/YYYY" value={dataSantri?.tanggal_lahir} onChange={(e) => { handleChange("tanggal_lahir", e) }} name='tanggal_lahir'>
                                </DatePicker>
                            </LocalizationProvider>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px", "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Jenis Kelamin</FormLabel>
                            <RadioGroup required value={dataSantri?.jenis_kelamin} onChange={(e) => { handleChange(e.target.name, e.target.value) }} name='jenis_kelamin' defaultValue={JENIS_KELAMIN.LAKILAKI} row>
                                <FormControlLabel value={JENIS_KELAMIN.LAKILAKI} control={<Radio></Radio>} label={JENIS_KELAMIN.LAKILAKI}></FormControlLabel>
                                <FormControlLabel value={JENIS_KELAMIN.PEREMPUAN} control={<Radio></Radio>} label={JENIS_KELAMIN.PEREMPUAN}></FormControlLabel>
                            </RadioGroup>

                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px", "::after": {
                                    content: '" *Wajib Diisi"', // Adds custom " (*)" after the label text
                                    color: "red",      // Customize color
                                    fontWeight: "bold", // Customize font weight
                                    fontStyle: "italic"
                                }
                            }}>Jenjang Tujuan</FormLabel>
                            <Select value={dataJenjang?.jenjang_tujuan ?? ''} onChange={(e) => { handleChange(e.target.name, e.target.value) }} name="jenjang_tujuan" required fullWidth>
                                {
                                    programs.length > 0 ? programs.map((program, index) => (
                                        <MenuItem key={index} value={program.nama_program}>{program.nama_program}</MenuItem>
                                    )) : (
                                        <MenuItem disabled>No programs available</MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}

export default PraDaftar;